module.exports = __webpack_public_path__ + "media/images/icon_btn_post_green-8ecb2faa93c6e602f037ce6a61249233.png";